import { Address } from "./address";

export class Assets {
  sType: number;
  sBankName: string;
  sAccountNo: string;
  sCashValue: number;
  sBankAddress = new Address();
  uiArrow = "arrow-down-outline";
  uiShowFlag = false;
  id : string;
}
